import LoginData from "../components/logindata";

function Login()
{
    return(
        <LoginData/>
    )

}
export default Login;